import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import Form from 'react-bootstrap/Form';
import HappyIcon from '../../design-system/design_system/assets/icons/general/feedback/happy.svg';
import LittleHappyIcon from '../../design-system/design_system/assets/icons/general/feedback/little-happy.svg';
import LittleUnhappyIcon from '../../design-system/design_system/assets/icons/general/feedback/little-unhappy.svg';
import OkayIcon from '../../design-system/design_system/assets/icons/general/feedback/okay.svg';
import UnhappyIcon from '../../design-system/design_system/assets/icons/general/feedback/unhappy.svg';
import SelectedHappyIcon from '../../design-system/design_system/assets/icons/general/feedback/happy-on.svg';
import SelectedLittleHappyIcon from '../../design-system/design_system/assets/icons/general/feedback/little-happy-on.svg';
import SelectedLittleUnhappyIcon from '../../design-system/design_system/assets/icons/general/feedback/little-unhappy-on.svg';
import SelectedOkayIcon from '../../design-system/design_system/assets/icons/general/feedback/okay-on.svg';
import SelectedUnhappyIcon from '../../design-system/design_system/assets/icons/general/feedback/unhappy-on.svg';
import { ReactComponent as CloseIcon } from '../../design-system/design_system/assets/icons/system/close.svg';
import OkIcon from '../../design-system/design_system/assets/icons/components/notifications/ok.svg';
import { FeedbackValidator } from './FeedbackValidator';
import { commentGTM, emailGTM } from '../../common/gtm/feedback';

const FeedbackRating = (props) => {
  const { closeFeedBack, footerContentInfo } = props;
  const feedbackClickToChat = get(footerContentInfo, 'FeedBackContainer');
  const [comment, setComment] = useState(false);
  const [next, setNext] = useState(false);
  const [thanksMsg, setThanksMsg] = useState(false);
  const [minComment, setMinComment] = useState(false);
  const [selectedEmoji, setselectedEmoji] = useState('');
  const [getCommentTextLength, setGetCommentTextLength] = useState(0);
  const [emailOption, setEmailOption] = useState(false);
  const [selectedEmojiOnhover, setselectedEmojiOnHover] = useState('');
  const closeFeedBackHandeler = (value) => {
    setComment(false);
    setNext(false);
    setThanksMsg(false);
    setMinComment(false);
    setselectedEmoji('');
    setGetCommentTextLength(0);
    setEmailOption(false);
    closeFeedBack(value);
  };
  const selectedEmojiArray = (ratingValue) => {
    const emojis = [
      { icon: SelectedUnhappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.VeryPoor'), rating: 1 },
      { icon: SelectedOkayIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Poor'), rating: 2 },
      { icon: SelectedLittleUnhappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Neutral'), rating: 3 },
      { icon: SelectedLittleHappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Like'), rating: 4 },
      { icon: SelectedHappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Love'), rating: 5 },
    ];
    const getEmoji = emojis.find(each => each.rating === ratingValue);
    return getEmoji.icon;
  };

  const [errorObject, seterrorObject] = useState({});
  const emojiArray = [
    { icon: UnhappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.VeryPoor'), rating: 1 },
    { icon: OkayIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Poor'), rating: 2 },
    { icon: LittleUnhappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Neutral'), rating: 3 },
    { icon: LittleHappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Like'), rating: 4 },
    { icon: HappyIcon, alt: get(feedbackClickToChat, 'SmileyHoverText.Love'), rating: 5 },
  ];
  const setCommentAndselectedHover = (selectedEmojis) => {
    setComment(true);
    setselectedEmoji(selectedEmojis);
  };
  const handleSend = () => {
    const emailValue = document.getElementById('email').value;
    const emailRegex = FeedbackValidator(emailValue, get(feedbackClickToChat, 'EmailValidationText'));
    if (Object.keys(emailRegex).length > 0) {
      setThanksMsg(false);
      seterrorObject(emailRegex);
    } else {
      emailGTM(emailValue);
      setThanksMsg(true);
      seterrorObject({});
    }
  };

  const getNextSection = (value) => {
    setNext(value);
    const experience = document.getElementById('experience').value;
    commentGTM(selectedEmoji, experience);
  };
 
  return (
    <section className="px-0 feedback-options shadow-2 bg-white rounded">
      <section className="rating-card p-3">
        <Button variant="ghost" className="position-absolute w-auto p-0 close-icon mb-4" onClick={() => closeFeedBackHandeler(false)} data-testid="rating-card-id">
          <CloseIcon className="svg-fill-black ds-svg-icon" />
        </Button>
        <section className={thanksMsg ? 'text-center mb-2' : 'text-center mb-3 pt-5'}>
          {!comment && (
          <p className="p-3 mb-0 font-weight-bold text-center">
            {get(feedbackClickToChat, 'FBWindowTitleText')}
          </p>
          )}
          {!next && (
          <div>
            {
            emojiArray.map((each, index) => (
              <React.Fragment key={each.rating}>
                <Button
                  variant="ghost"
                   // disabled={comment}
                  className="p-0 w-auto"
                  onClick={() => setCommentAndselectedHover(each.rating)}
                  onMouseOut={() => {
                    setselectedEmojiOnHover('');
                  }
                  }
                  onFocus={() => setselectedEmojiOnHover(each.rating)}
                  onMouseOver={() => setselectedEmojiOnHover(each.rating)}
                  onBlur={() => {
                    setselectedEmojiOnHover('');
                  }
                  }
                  data-testid={`selected-emogi-${index}`}
                >
                   {selectedEmoji === each.rating || selectedEmojiOnhover === each.rating ? <img src={selectedEmojiArray(each.rating)} className="px-1" alt={each.alt} />
                    : <img src={each.icon} className="px-1" alt={each.alt} />}
                </Button>

              </React.Fragment>
            ))
          }
          </div>
          )}
        </section>
        {(comment && !next) && (
        <React.Fragment>
          <Form.Label
            className={
              `float-right heading ${parseInt(getCommentTextLength, 10) === parseInt(get(feedbackClickToChat, 'FBCharactersLimit'), 10) && 'text-danger'}`
            }
          >
            {getCommentTextLength}
              /
            {get(feedbackClickToChat, 'FBCharactersLimit')}
          </Form.Label>
          <Form.Control
            as="textarea"
            maxLength={get(feedbackClickToChat, 'FBCharactersLimit')}
            id="experience"
            placeholder={get(feedbackClickToChat, 'FBDefaultDisplayText')}
            className="px-2 font-weight-normal"
            rows="3"
            data-testid="tell-about-your-experience"
            required
            onChange={(e) => {
              if (e.target.value.length > 0) {
                setMinComment(true);
                setGetCommentTextLength(e.target.value.length);
              } else {
                setMinComment(false);
                setGetCommentTextLength(e.target.value.length);
              }
            }}
          />
          <Button
            variant="primary"
            className="mt-3 w-100 py-2 text-white"
            onClick={() => getNextSection(true)}
            disabled={!minComment}
            data-testid="next-feedback-button"
          >
            {get(feedbackClickToChat, 'FBNextButtonText')}
          </Button>
        </React.Fragment>
        )}
        {(next && !thanksMsg) && (
        <React.Fragment>
          <section className="content-body">
            <Form.Control
              type="email"
              required
              id="email"
              placeholder={get(feedbackClickToChat, 'FBDefaultEmailText')}
              className={`px-2 font-weight-normal mt-5 ${Object.keys(errorObject).length > 0 && 'border-danger'}`}
              rows="1"
              onChange={(e) => {
                seterrorObject({});
                if (e.target.value.length > 0) {
                  setEmailOption(true);
                } else {
                  setEmailOption(false);
                }
              }}
              onFocus={() => seterrorObject({})}
              data-testid="EmailPlaceholderText-chat"
            />
          </section>
          <span className="text-danger">
            {Object.keys(errorObject).length > 0 && errorObject.feedbackEmail}
          </span>
          <Button variant="ghost" className="mt-2 w-100 py-2" onClick={() => setThanksMsg(true)} data-testid="skip-feedback">
            {get(feedbackClickToChat, 'FBSkipButtonText')}
          </Button>
          <Button
            variant="primary"
            className="mt-2 w-100 py-2 text-white"
            onClick={() => handleSend()}
            disabled={!emailOption}
            data-testid="send-feedback"
          >
            {get(feedbackClickToChat, 'FBSendButtonText')}
          </Button>
        </React.Fragment>
        )}
        {thanksMsg && (
        <div className="text-center">
          <img src={OkIcon} alt="" />
          <p className="my-2 font-weight-bold">
            {get(feedbackClickToChat, 'ThankyouText')}
          </p>
        </div>
        )}
      </section>
    </section>
  );
};

FeedbackRating.propTypes = {
  closeFeedBack: PropTypes.func.isRequired,
  footerContentInfo: PropTypes.instanceOf(Object).isRequired,
};


const mapStateToProps = state => ({
  footerContentInfo: state.CommonReducer.footerData,
});
export default connect(
  mapStateToProps,
  null,
)(FeedbackRating);
